const baseUrl = process.env.API_BASE_URL || 'http://api.sqrl.dev.krupix.com'
const signup = `${baseUrl}/api/user/signup`

export { baseUrl, signup }
